// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/accept_pricing_one.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.AcceptPricingOneRequest
 */
export class AcceptPricingOneRequest extends Message<AcceptPricingOneRequest> {
  /**
   * Unique identifier for the price history record
   *
   * @generated from field: string price_history_id = 1;
   */
  priceHistoryId = "";

  constructor(data?: PartialMessage<AcceptPricingOneRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AcceptPricingOneRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "price_history_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPricingOneRequest {
    return new AcceptPricingOneRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPricingOneRequest {
    return new AcceptPricingOneRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPricingOneRequest {
    return new AcceptPricingOneRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPricingOneRequest | PlainMessage<AcceptPricingOneRequest> | undefined, b: AcceptPricingOneRequest | PlainMessage<AcceptPricingOneRequest> | undefined): boolean {
    return proto3.util.equals(AcceptPricingOneRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AcceptPricingOneResponse
 */
export class AcceptPricingOneResponse extends Message<AcceptPricingOneResponse> {
  constructor(data?: PartialMessage<AcceptPricingOneResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AcceptPricingOneResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPricingOneResponse {
    return new AcceptPricingOneResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPricingOneResponse {
    return new AcceptPricingOneResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPricingOneResponse {
    return new AcceptPricingOneResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPricingOneResponse | PlainMessage<AcceptPricingOneResponse> | undefined, b: AcceptPricingOneResponse | PlainMessage<AcceptPricingOneResponse> | undefined): boolean {
    return proto3.util.equals(AcceptPricingOneResponse, a, b);
  }
}

